/**
 * Add page/section specific features here.
 *
 * To load a feature on more than one page,
 * separate each class name with a comma and a space
 * @type {Object}
 */

import corePages from '*/pages';

corePages.profileEdit = {
    default: '[data-action="Account-EditProfile"]',
    init: function() {
        return import(/* webpackChunkName: "profile-edit" */ '../account/profileEdit').then(function(profileEdit) {
            return profileEdit.default();
        });
    }
}

corePages.subscriptions = {
    default: '[data-action="Account-Subscriptions"]',
    init: function() {
        return import(/* webpackChunkName: "account-subscriptions" */ '../account/subscriptions').then(function(subscriptions) {
            return subscriptions.default();
        });
    }
}

corePages.requestprice = {
    default: '[data-action="Product-Show"], [data-action="Search-Show"]',
    init: function() {
        return import(/* webpackChunkName: "page-requestprice" */ '../price').then(function(price) {
            return price.default();
        });
    }
}

export default corePages;
